module.exports = "/lucky-balls/img/drum/drum_loop_037.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_037.png
// module id = 1052
// module chunks = 0